import { JsonProperty, JsonObject } from "json2typescript";
import { PublicationListItem } from "src/models/PublicationListItem";

@JsonObject("AuthorDetail")
export class AuthorDetail {
    
    @JsonProperty("first_name", String)
    public first_name: string = "";

    @JsonProperty("last_name", String)
    public last_name: string = "" ;

    @JsonProperty("affiliation", String)
    public affiliation: string = "";

    @JsonProperty("publications", [])
    public publications: PublicationListItem[] = [];

}


// WEBPACK FOOTER //
// ./src/models/AuthorDetail.ts